module.exports = __webpack_public_path__ + "ipetbooking/admin/img/lineFriend_1.ba5a47c6.jpg";